import {Component, Input} from '@angular/core';

@Component({
    selector: 'zah-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    standalone: false
})
export class AvatarComponent {

  @Input()
  name: string;
  @Input()
  color: 'primary' | 'accent' | 'disabled' = 'primary';

  getFirstLetter(): string {
    return this.name.substr(0, 1);
  }
}
